import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=63f6178a&"
import script from "./PagePagination.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PagePagination.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f6178a')) {
      api.createRecord('63f6178a', component.options)
    } else {
      api.reload('63f6178a', component.options)
    }
    module.hot.accept("./PagePagination.vue?vue&type=template&id=63f6178a&", function () {
      api.rerender('63f6178a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PagePagination/PagePagination.vue"
export default component.exports